import MobileObjectContextMenu from './MobileObjectContextMenu'

export default MobileObjectContextMenu;